if (typeof Promise === 'undefined') {
  window.Promise = require('promise-polyfill').default;
}

import 'unfetch/polyfill';

// Will use the native implementation if it's not bad
Object.assign = require('object-assign');
